const i = {
  CA_PACKAGE_ERROR: "CA001"
}, a = (o, t, c) => {
  const e = {
    locale: c,
    env: t.includes("production") ? "production" : "dev",
    logCode: i[o],
    logName: o
  };
  switch (o) {
    case "CA_PACKAGE_ERROR":
    default:
      return Object.assign(Object.assign({}, e), { logLevel: "error", message: "CA: Error occured " });
  }
}, s = (o, t, c, e) => {
  if (t.includes("production") || t.includes("sandbox")) {
    let r = a(o, t, c);
    typeof e in ["boolean", "string", "number"] ? r = Object.assign(Object.assign({}, r), { additionalInfo: e }) : typeof e == "object" && (r = Object.assign(Object.assign({}, r), e)), console.info(o, { attributes: r }), window && window.newrelic && window.newrelic.addPageAction("chat_anywhere_package", Object.assign({}, r));
  } else
    console.info("NR Logging disabled for DEV environment ");
}, d = (o, t) => {
  try {
    const c = o === "vcs" ? "https://chat-anywhere.care.vpsvc.com/JS-build/en-us/ca-vistaNext-production-en-us.js" : "https://chat-anywhere.care.vpsvc.com/JS-build/ca-global-controller.js", e = () => {
      const r = document.createElement("script");
      r.setAttribute("src", c), r.onload = () => {
        window.CAScriptLoaded = !0;
      }, r.onerror = (n) => {
        s("CA_PACKAGE_ERROR", "production", void 0, {
          errorName: "CA Script Load Error",
          errorMessage: "onerror Called",
          errorObject: JSON.stringify(n)
        });
      }, document && document.head && !window.CAScriptLoaded && document.head.appendChild(r);
    };
    t ? setTimeout(e, 3e3) : e();
  } catch (c) {
    const e = c;
    console.error("Error in loading CHAT ANYWHERE script", c), s("CA_PACKAGE_ERROR", "production", void 0, {
      errorName: "CA Script Load Error",
      error: e.name,
      errorMessage: e.message
    });
  }
};
export {
  d as initCA
};
//# sourceMappingURL=contact-channels51.js.map
